export const COLORS = {
  bg: "#030404",
  bg2: "#070808",
  top: "#0d0d0d",
  panel: "#0c0d0d",
  border: "#5e5a51",
  borderSoft: "#282b2c",
  text: "#d9d2c5",
  text2: "#aaa399",
  muted: "#77726c",
  green: "#00d978",
  green2: "#0aad67",
  red: "#ff3333",
  red2: "#b00012",
  orange: "#ff9f1a",
  amber: "#d39a00",
  yellow: "#ffd32a",
  blue: "#2aa8ff",
  cyan: "#00e5ff",
  purple: "#8d6cff",
};

export const FETCH_STORAGE_KEY = "world_monitor_fetch_enabled";

export const LAYERS = [
  { id: "iran", label: "IRAN ATTACKS", icon: "IR", color: COLORS.red, checked: true },
  { id: "intel", label: "INTEL HOTSPOTS", icon: "IH", color: COLORS.cyan, checked: true },
  { id: "conflict", label: "CONFLICT ZONES", icon: "CZ", color: COLORS.red, checked: true },
  { id: "bases", label: "MILITARY BASES", icon: "MB", color: COLORS.blue, checked: true },
  { id: "nuclear", label: "NUCLEAR SITES", icon: "NU", color: COLORS.yellow, checked: true },
  { id: "gamma", label: "GAMMA IRRADIATORS", icon: "GI", color: "#bbbbbb", checked: false },
  { id: "sanctions", label: "SANCTIONS", icon: "SA", color: COLORS.amber, checked: true },
  { id: "weather", label: "WEATHER", icon: "WX", color: COLORS.blue, checked: true },
  { id: "economic", label: "ECONOMIC STRESS", icon: "EC", color: COLORS.green, checked: true },
  { id: "waterways", label: "WATERWAYS", icon: "WW", color: "#2dd4bf", checked: true },
  { id: "outages", label: "OUTAGES", icon: "PO", color: COLORS.orange, checked: true },
  { id: "natural", label: "NATURAL HAZARDS", icon: "NH", color: "#b4ff20", checked: true },
];

export const NEWS_CHANNELS = [
  { key: "ALJAZEERA", label: "AL JAZEERA", liveVideoId: "gCNeDWCI0vo", official: "https://www.youtube.com/@AlJazeeraEnglish/live" },
  { key: "DW", label: "DW NEWS", liveVideoId: "GE_SfNVNyqk", official: "https://www.youtube.com/@dwnews/live" },
  { key: "FRANCE24", label: "FRANCE 24", liveVideoId: "Ap-UM1O9RBU", official: "https://www.youtube.com/@FRANCE24English/live" },
  { key: "EURONEWS", label: "EURONEWS", liveVideoId: "pykpO5kQJ98", official: "https://www.youtube.com/@euronews/live" },
  { key: "WION", label: "WION", liveVideoId: "L4Q83iFl4vM", official: "https://www.youtube.com/@WIONNews/live" },
  { key: "SKYNEWS", label: "SKY NEWS", liveVideoId: "9Auq9mYxFEE", official: "https://www.youtube.com/@SkyNews/live" },
  { key: "BLOOMBERG", label: "BLOOMBERG", liveVideoId: "", official: "https://www.youtube.com/@Bloomberg/live" },
  { key: "CNN", label: "CNN", liveVideoId: "", official: "https://www.youtube.com/@CNN/live" },
  { key: "CNBC", label: "CNBC", liveVideoId: "", official: "https://www.youtube.com/@CNBCtelevision/live" },
];

export const WEBCAM_FEEDS = [
  { key: "jerusalem", label: "JERUSALEM", region: "MIDEAST", liveVideoId: "", official: "https://www.youtube.com/results?search_query=Jerusalem+live+webcam+24%2F7" },
  { key: "intelcams", label: "MIDDLE EAST", region: "MIDEAST", liveVideoId: "", official: "https://www.youtube.com/@intelcamslive/live" },
  { key: "telaviv", label: "TEL AVIV", region: "MIDEAST", liveVideoId: "", official: "https://www.youtube.com/results?search_query=Tel+Aviv+live+webcam+24%2F7" },
  { key: "beirut", label: "BEIRUT", region: "MIDEAST", liveVideoId: "", official: "https://www.youtube.com/results?search_query=Beirut+live+webcam+24%2F7" },
  { key: "kyiv", label: "KYIV", region: "EUROPE", liveVideoId: "", official: "https://www.youtube.com/results?search_query=Kyiv+live+webcam+24%2F7" },
  { key: "paris", label: "PARIS", region: "EUROPE", liveVideoId: "AdUw5RdyZxI", official: "https://www.youtube.com/watch?v=AdUw5RdyZxI" },
  { key: "london", label: "LONDON", region: "EUROPE", liveVideoId: "", official: "https://www.youtube.com/results?search_query=London+live+webcam+24%2F7" },
  { key: "rome", label: "ROME", region: "EUROPE", liveVideoId: "", official: "https://www.youtube.com/results?search_query=Rome+live+webcam+24%2F7" },
  { key: "washingtondc", label: "WASHINGTON DC", region: "AMERICAS", liveVideoId: "", official: "https://www.youtube.com/results?search_query=Washington+DC+live+webcam+24%2F7" },
  { key: "newyork", label: "NEW YORK", region: "AMERICAS", liveVideoId: "", official: "https://www.youtube.com/results?search_query=New+York+live+webcam+24%2F7" },
  { key: "chicago", label: "CHICAGO", region: "AMERICAS", liveVideoId: "IIV87bFjfo0", official: "https://www.youtube.com/watch?v=IIV87bFjfo0" },
  { key: "tokyo", label: "TOKYO", region: "ASIA", liveVideoId: "", official: "https://www.youtube.com/results?search_query=Tokyo+live+webcam+24%2F7" },
  { key: "singapore", label: "SINGAPORE", region: "ASIA", liveVideoId: "", official: "https://www.youtube.com/results?search_query=Singapore+live+webcam+24%2F7" },
  { key: "shanghai", label: "SHANGHAI", region: "ASIA", liveVideoId: "", official: "https://www.youtube.com/results?search_query=Shanghai+live+webcam+24%2F7" },
  { key: "iss", label: "ISS LIVE", region: "SPACE", liveVideoId: "21X5lGlDOfg", official: "https://www.youtube.com/watch?v=21X5lGlDOfg" },
  { key: "nasatv", label: "NASA TV", region: "SPACE", liveVideoId: "nA9UZF-SZoQ", official: "https://www.youtube.com/watch?v=nA9UZF-SZoQ" },
];

export const VIDEO_CHANNELS = NEWS_CHANNELS;

export const FALLBACK_MAP_EVENTS = [
  { id: 1, layer: "iran", title: "Iran missile posture", label: "Iran", x: 59, y: 34, level: "critical", size: 18 },
  { id: 2, layer: "conflict", title: "Ukraine front", label: "Ukraine", x: 53, y: 25, level: "critical", size: 12 },
  { id: 3, layer: "intel", title: "Taiwan Strait hotspot", label: "Taiwan", x: 81, y: 44, level: "high", size: 11 },
  { id: 4, layer: "bases", title: "Diego Garcia base", label: "Indian Ocean", x: 66, y: 62, level: "monitoring", size: 8 },
  { id: 5, layer: "waterways", title: "Hormuz shipping risk", label: "Hormuz", x: 58, y: 43, level: "high", size: 13 },
  { id: 6, layer: "weather", title: "Philippines storm band", label: "Philippines", x: 82, y: 55, level: "elevated", size: 10 },
  { id: 7, layer: "outages", title: "South Africa grid outage", label: "South Africa", x: 53, y: 77, level: "elevated", size: 10 },
  { id: 8, layer: "nuclear", title: "Korea nuclear watch", label: "Korea", x: 79, y: 32, level: "critical", size: 9 },
];

export const FALLBACK_NEWS = [
  { source: "AP NEWS", tags: ["ONGOING", "ALERT"], title: "US and Iran talks continue as markets watch sanctions and oil routes", time: "22 hours ago" },
  { source: "REUTERS", tags: ["ENERGY"], title: "Oil settles lower as ceasefire hopes cut risk premium", time: "8 hours ago" },
  { source: "LOCAL MONITOR", tags: ["MILITARY"], title: "Air traffic anomaly cluster appears near active theater", time: "38 minutes ago" },
];

export const FALLBACK_COUNTRIES = [
  { country: "Ukraine", score: 74, delta: "+2", bars: { u: 0, c: 0, s: 49, i: 0 } },
  { country: "Myanmar", score: 71, delta: "+11", bars: { u: 0, c: 0, s: 55, i: 0 } },
  { country: "Pakistan", score: 70, delta: "->", bars: { u: 0, c: 0, s: 35, i: 0 } },
  { country: "Iran", score: 66, delta: "+14", bars: { u: 0, c: 18, s: 25, i: 0 } },
];

export const FALLBACK_MARKETS = [
  { name: "Apple", symbol: "AAPL", price: "$298.01", change: "+0.70%" },
  { name: "Amazon", symbol: "AMZN", price: "$244.39", change: "+2.90%" },
  { name: "Broadcom", symbol: "AVGO", price: "$411.35", change: "+4.70%" },
  { name: "Nvidia", symbol: "NVDA", price: "$144.12", change: "-0.54%" },
];

export const FALLBACK_COMMODITIES = [
  { name: "GOLD", price: "$4,155", change: "-2.15%", points: [70, 64, 66, 61, 57, 56, 51, 46] },
  { name: "SILVER", price: "$64.08", change: "-3.38%", points: [61, 59, 55, 58, 54, 50, 47, 43] },
  { name: "COPPER", price: "$6.31", change: "-1.12%", points: [48, 51, 49, 56, 52, 50, 47, 45] },
];

export const FALLBACK_ENERGY = [
  { title: "OIL TAPE", value: "$76.56", change: "+0.34%", date: "live", color: COLORS.green, points: [42, 36, 41, 38, 47, 45, 52, 50] },
  { title: "BRENT BENCHMARK", value: "$80.47", change: "+0.21%", date: "live", color: COLORS.green, points: [44, 45, 43, 47, 46, 51, 55, 57] },
  { title: "NAT GAS", value: "$3.20", change: "-1.18%", date: "live", color: COLORS.red, points: [55, 51, 48, 45, 47, 43, 40, 39] },
];

export const FALLBACK_REGIONS = [
  {
    title: "UNITED STATES",
    count: 2,
    items: [
      { source: "ABC NEWS", tags: ["ALERT"], title: "Comparing Iran deals and sanctions pressure", time: "8 hours ago" },
      { source: "NPR NEWS", tags: ["DIPLOMATIC"], title: "Port restrictions and final deal clock monitored", time: "6 hours ago" },
    ],
  },
  {
    title: "EUROPE",
    count: 2,
    items: [
      { source: "DW NEWS", tags: ["CAUTION"], title: "US-Iran talks in doubt as Europe watches defense risk", time: "3 hours ago" },
      { source: "FRANCE 24", tags: ["ECONOMIC"], title: "Tariff pressure rises across pharma and energy markets", time: "4 hours ago" },
    ],
  },
  {
    title: "MIDDLE EAST",
    count: 2,
    items: [
      { source: "GUARDIAN ME", tags: ["CONFLICT"], title: "Ceasefire hopes watched across Lebanon and Israel", time: "11 hours ago" },
      { source: "BBC MIDDLE EAST", tags: ["DIPLOMATIC"], title: "Talks resume as oil markets watch Strait of Hormuz", time: "5 hours ago" },
    ],
  },
];

export const TABS = [
  { id: "map", label: "Global Map" },
  { id: "videos", label: "Live Videos / Webcams" },
  { id: "intel", label: "Intelligence" },
  { id: "markets", label: "Markets / Energy" },
  { id: "regions", label: "Regional News" },
];
